type UserDtoAttributes = {
    accountId: string
    createdAt: string
    createdBy: string
    firstName: string
    name: string
    lastName: string
    locationId: string
    role: string
}

export type UserDto = {
    id: string,
    type: string,
    attributes: UserDtoAttributes
}

export default class User {
    private dto: UserDto
    constructor(dto: UserDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "users"
    }

    getId(): string {
        return this.dto.id
    }

    getAttributes(): UserDtoAttributes {
        return this.dto.attributes
    }
}


// WEBPACK FOOTER //
// ./src/state/user/User.ts